export default __webpack_public_path__ + "static/media/icon-nps-analysis.20792e77.svg";